import type { ImgHTMLAttributes } from 'react';
import type { Image } from '@content/types';

/** An image from a CMS image field; renders nothing when the field is empty. */
export function Img({
  image,
  ...props
}: { image: Image | null | undefined } & Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'>) {
  if (!image) return null;
  return <img src={image.src} srcSet={image.srcSet} sizes={image.sizes} alt={image.alt ?? ''} {...props} />;
}
